import { render } from "./dashboard.layouts.vue?vue&type=template&id=53513ad9"
import script from "./dashboard.layouts.vue?vue&type=script&lang=js"
export * from "./dashboard.layouts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__